<template>
  <GenericCard
    :locked="locked"
    has-delete
    :on-delete="onCardDelete"
    :on-action="submitForm"
    :on-refresh="onCardRefresh"
    :invalid="v$.section.$invalid"
    :dirty="v$.section.$anyDirty"
    :create="create"
    title="Firm Resettlement"
    :section="section"
    has-footer
    has-share
    :card-identifier="cardIdentifier"
  >
    <v-form
      :disabled="locked"
      @submit.prevent="submitForm"
    >
      <v-row>
        <v-col cols="12">
          <v-alert
            border="left"
            colored-border
            color="#2A3B4D"
            icon="mdi-information-outline"
            elevation="2"
            class="mb-6"
          >
            Firm resettlement means an offer of permanent status or permanent resettlement unless an exception applies. Add a module for each putative country.
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          cols="12"
          sm="5"
        >
          <v-autocomplete
            v-model="section.country_id"
            outlined
            item-text="name"
            item-value="id"
            :items="optionsCountries"
            label="Putative Firm Resettle Country"
          />
        </v-col>
        <v-col
          cols="12"
          sm="7"
        >
          <!-- A list of stacked elements: -->
          <div>
            <v-checkbox
              v-model="section.offer_of_permanent_residence"
              hide-details
            >
              <div slot="label">
                Offer of Permanent Residence
              </div>
            </v-checkbox>
          </div>
          <div>
            <v-checkbox
              v-model="section.citizenship"
              hide-details
            >
              <div slot="label">
                Citizenship
              </div>
            </v-checkbox>
          </div>
          <div>
            <v-checkbox
              v-model="section.other_firm_resettlement"
              hide-details
            >
              <div slot="label">
                Other firm resettlement
              </div>
            </v-checkbox>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div>
            Exception: Necessary exception on restrictive conditions
          </div>
        </v-col>
        <v-col cols="12">
          <v-textarea
            v-model="section.narrative"
            auto-grow
            outlined
            autocomplete="off"
            label="Narrative"
          />
        </v-col>
      </v-row>
    </v-form>
  </GenericCard>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { useVuelidate } from '@vuelidate/core'

import { PARTY_NAMESPACE } from '@/store/party'
import { alertHandler } from '@/alertHandler'

import GenericCard from '@/components/Party/PartyEdit/SectionCards/GenericCard'
import { SHARED_NAMESPACE } from '@/store/shared'

export default {
  name: 'FirmResettlementsCard',
  components: { GenericCard },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  setup () {
    return {
      v$: useVuelidate(),
      ...alertHandler(),
    }
  },

  data () {
    return {
      section: {},
    }
  },

  validations () {
    return {
      section: {},
    }
  },

  computed: {
    cardIdentifier () { return `firm-resettlement-card-${this.sectionIdentifier}` },
    create () { return this.item.id === null },

    locked: {
      get () {
        return this.peFirmResettlementsCardLock(this.sectionIdentifier)
      },

      set (value) {
        this.setPeFirmResettlementsCardLock({ index: this.sectionIdentifier, locked: value })
      },
    },

    optionsCountries () { return this.getCachedDropdown('countries') },
    sectionIdentifier () { return this.section.id || 'new' },

    subtitle () {
      if (this.create) return ''
      return `(${this.section.name})`
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peFirmResettlementsCardLock',
    ]),

    ...mapGetters(SHARED_NAMESPACE, [
      'getCachedDropdown',
    ]),
  },

  watch: {
    item: {
      immediate: true,

      handler: function () {
        this.section = { ...this.item }
      },

      deep: true,
    },
  },

  created () {
    if (!this.create) this.initPeFirmResettlementsCard(this.sectionIdentifier)
    this.getDropdownOptions({ options: false, path: 'countries' })
  },

  methods: {
    getErrorMessages (validator) { return validator?.$errors.map(e => e.$message) },

    async onCardCreate () {
      return this.peFirmResettlementsCardCreate({ index: this.sectionIdentifier, section: this.section })
    },

    async onCardDelete () {
      if (this.create) return this.peFirmResettlementsCardCreateUndo()
      else {
        return this.peFirmResettlementsCardDelete({ id: this.section.id, index: this.sectionIdentifier })
      }
    },

    async onCardRefresh () {
      return this.peFirmResettlementsCardRefresh({ index: this.sectionIdentifier, section: this.section })
    },

    async onCardUpdate () {
      return this.peFirmResettlementsCardUpdate({
        id: this.section.id,
        index: this.sectionIdentifier,
        section: this.section,
      })
    },

    async onSectionUnlock () {
      return this.setPeFirmResettlementsCardLock({ index: this.sectionIdentifier, locked: false })
    },

    async submitForm () {
      if (this.locked) return this.onSectionUnlock()
      else if (this.create) return this.onCardCreate()
      else return this.onCardUpdate()
    },

    ...mapMutations(PARTY_NAMESPACE, [
      'peFirmResettlementsCardCreateUndo',
      'setPeFirmResettlementsCardLock',

    ]),

    ...mapActions(PARTY_NAMESPACE, [
      'initPeFirmResettlementsCard',
      'peFirmResettlementsCardCreate',
      'peFirmResettlementsCardDelete',
      'peFirmResettlementsCardRefresh',
      'peFirmResettlementsCardUpdate',
    ]),

    ...mapActions(SHARED_NAMESPACE, [
      'getDropdownOptions',
    ]),
  },
}
</script>
